import { render, staticRenderFns } from "./CopyPaxChanges.vue?vue&type=template&id=0260c526&scoped=true&"
import script from "./CopyPaxChanges.vue?vue&type=script&lang=js&"
export * from "./CopyPaxChanges.vue?vue&type=script&lang=js&"
import style0 from "./CopyPaxChanges.vue?vue&type=style&index=0&id=0260c526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260c526",
  null
  
)

export default component.exports